import { api } from "./utils";

// Get all facilities with filters
export const getFacilities = async (filters = {}) => {
  try {
    const params = new URLSearchParams();

    if (filters.search) params.append("search", filters.search);
    if (filters.location) params.append("location", filters.location);
    if (filters.facilityType && filters.facilityType !== "all")
      params.append("facilityType", filters.facilityType);
    if (filters.sortBy) params.append("sortBy", filters.sortBy);
    if (filters.page) params.append("page", filters.page);
    if (filters.limit) params.append("limit", filters.limit);

    const response = await api.get(
      `/childcare/facilities?${params.toString()}`,
    );
    return response;
  } catch (error) {
    console.error("Error fetching facilities:", error);
    throw error;
  }
};

// Get single facility details
export const getFacilityById = async (id) => {
  try {
    const response = await api.get(`/childcare/facilities/${id}`);
    return response;
  } catch (error) {
    console.error("Error fetching facility details:", error);
    throw error;
  }
};

// Get filter options
export const getFilterOptions = async () => {
  try {
    const response = await api.get("/childcare/filter-options");
    return response;
  } catch (error) {
    console.error("Error fetching filter options:", error);
    throw error;
  }
};
